export const winPopupShownMinOdd = 15;

export const WinningLinesCoordinate100 = [
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 1, y: 2 },
    { x: 1, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 2, y: 2 },
    { x: 2, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 3, y: 1 },
    { x: 3, y: 2 },
    { x: 3, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 3, y: 2 },
    { x: 3, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 1, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 2, y: 1 },
    { x: 2, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 2, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 3, y: 1 },
    { x: 1, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 0, y: 1 },
    { x: 2, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 3, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 3, y: 1 },
    { x: 3, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 2, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 3, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 3, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 3, y: 2 },
    { x: 0, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 3, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 3, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 2, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 1, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 3, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 2, y: 1 },
    { x: 3, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 0, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 3, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 0, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 3, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 3, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 3, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 3, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 3, y: 2 },
    { x: 3, y: 3 },
    { x: 0, y: 4 },
  ],
];
